import React from "react";
import indiamap from "assets/img/indiamap.png";
import uaemap from "assets/img/uaemap.png";
import Homebg from "assets/img/homebg.png";
import indiaBg from "assets/img/indiabg.jpg";

export default function Homepagenext() {
  
  const slideDownText = {
    animation: 'slideDown 1.2s ease-out',
  };

  return (
    <section
      className="dblue min-h-screen flex flex-col items-center justify-center bg-cover bg-center text-white text-center px-4"
      style={{ backgroundImage: `url(${Homebg})` }}
    >
      {/* Heading Section with slide down animation */}
      <div className="xl:mb-12 md:mb-12 lg:mb-12 mb-8 text-white text-center">
        <h1 
          className="xl:text-6xl md:text-5xl lg:text-4xl text-2xl font-bold"
          style={slideDownText}
        >
          WELCOME TO
        </h1>
        <h2 
          className="xl:text-6xl md:text-5xl lg:text-4xl text-2xl font-bold xl:mt-2 md:mt-2 lg:mt-2 mt-0"
          style={slideDownText}
        >
          INNOVATIVE PROCESS TECHNOLOGIES
        </h2>
       
      </div>

      {/* Country Buttons */}
      <div className="container mx-auto"> <p className="xl:text-2xl md:text-xl lg:text-2xl text-lg xl:mt-2 lg:mt-2 md:mt-2 mt-0 ">Select Your Region</p></div>
      <div className="flex flex-wrap justify-center xl:gap-6 md:gap-6 lg:gap-6 gap-6 xl:mt-8 lg:mt-6 md:mt-8 mt-4">
        <a href="/india">
          <button
            className="relative xl:px-24  md:px-16 md:py-16 lg:px-16 lg:py-16 xl:py-8 px-16 py-8 rounded text-2xl flex flex-col items-center gap-2 shadow-lg text-black overflow-hidden transition-all duration-300"
            style={{
              backgroundImage: `url(${indiaBg})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <div className="bg-opacity-80 rounded flex flex-col items-center xl:p-4">
              <img src={indiamap} alt="India Map" className="xl:w-32 xl:h-32 md:w-24 md:h-24 w-20 h-20" />
            </div>
            <span className="font-semibold bluetext xl:text-3xl md:text-2xl lg:text-3xl text-2xl">INDIA</span>
          </button>
        </a>

        <a href="/UAE">
          <button
            className="relative xl:px-24 md:px-16 md:py-16 lg:px-16 lg:py-16 xl:py-8 px-16 py-8 rounded text-2xl flex flex-col items-center gap-2 shadow-lg text-black overflow-hidden transition-all duration-300"
            style={{
              backgroundImage: `url(${indiaBg})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <div className="bg-opacity-80 rounded flex flex-col items-center xl:p-4">
              <img src={uaemap} alt="UAE Map" className="xl:w-32 xl:h-32 md:w-24 md:h-24 w-20 h-20" />
            </div>
            <span className="font-semibold bluetext  xl:text-3xl md:text-2xl lg:text-3xl text-2xl">UAE</span>
          </button>
        </a>
      </div>

      {/* Slide Down Animation Keyframes */}
      <style>
        {`
          @keyframes slideDown {
            0% {
              opacity: 0;
              transform: translateY(-40px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </section>
  );
}
